// extracted by mini-css-extract-plugin
export default {"central":"FinalProcessView_central__T9MwN","buttons":"FinalProcessView_buttons__QKJUJ"};